module.exports = __webpack_public_path__ + "static/img/user.79a89d.svg";